import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { MyHistoryComponent } from './my-history/my-history.component';
import { hasChaptersGuard } from './my-history/chapter/has-chapters.guard';
import { FriendsComponent } from './friends/friends.component';
import { routePath } from './shared/app.config';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: routePath.myHistory,
        pathMatch: 'full',
      },
      {
        path: routePath.myHistory,
        component: MyHistoryComponent,
        children: [
          {
            path: '',
            loadComponent: () => import('./my-history/facet/facet.component').then((c) => c.FacetComponent),
            children: [
              {
                path: '',
                redirectTo: routePath.chapters,
                pathMatch: 'full',
              },
              {
                path: routePath.chapters,
                canMatch: [hasChaptersGuard],
                loadComponent: () =>
                  import('./my-history/chapter/chapters/chapters.component').then((c) => c.ChaptersComponent),
                data: {
                  withFacetFilter: true,
                  withDateFilter: true,
                },
              },
              {
                path: routePath.createPlace,
                loadComponent: () =>
                  import('./my-history/home/create-place/create-place.component').then((c) => c.CreatePlaceComponent),
              },
              {
                path: routePath.chapter,
                loadComponent: () =>
                  import('./my-history/chapter/chapter/chapter.component').then((c) => c.ChapterComponent),
                data: {
                  withDateFilter: true,
                },
              },
            ],
          },
          {
            path: routePath.stories,
            canActivate: [hasChaptersGuard],
            loadComponent: () => import('./my-history/story/stories/stories.component').then((c) => c.StoriesComponent),
          },
          {
            path: routePath.storiesByFacet,
            canActivate: [hasChaptersGuard],
            loadComponent: () =>
              import('./my-history/story/stories/stories-by-facet/stories-by-facet.component').then(
                (c) => c.StoriesByFacetComponent,
              ),
          },
        ],
      },
      {
        path: routePath.friends,
        component: FriendsComponent,
        children: [
          {
            path: '',
            redirectTo: routePath.friendsList,
            pathMatch: 'full',
          },
          {
            path: routePath.friendsList,
            loadComponent: () =>
              import('./friends/friends-list/friends-list.component').then((c) => c.FriendsListComponent),
          },
        ],
      },
      {
        path: routePath.myProfile,
        canActivate: [authGuard],
        loadComponent: () => import('./profile/my-profile/my-profile.component')
          .then((c) => c.MyProfileComponent),
      },
    ],
  },
  {
    path: routePath.guestOverview,
    children: [
      {
        path: routePath.story,
        loadComponent: () =>
          import('./my-history/story/guest-story-overview/guest-story-overview.component').then(
            (c) => c.GuestStoryOverviewComponent,
          ),
      },
    ],
  },
  {
    path: routePath.signUp,
    loadComponent: () => import('./auth/sign-up/sign-up.component').then((c) => c.SignUpComponent),
  },
  {
    path: routePath.privacyPolicy,
    loadComponent: () =>
      import('./general/privacy-policy/privacy-policy.component').then((c) => c.PrivacyPolicyComponent),
  },
  {
    path: routePath.termsConditions,
    loadComponent: () =>
      import('./general/terms-and-conditions/terms-and-conditions.component').then(
        (c) => c.TermsAndConditionsComponent,
      ),
  },
  {
    path: routePath.trademarkAppealForm,
    loadComponent: () =>
      import('./general/appeal-contact-form/appeal-contact-form.component').then(
        (c) => c.AppealContactFormComponent,
      ),
  },
  {
    path: routePath.privacyRequest,
    loadComponent: () =>
      import('./general/opt-out-data-request-form/opt-out-data-request-form.component').then(
        (c) => c.OptOutDataRequestFormComponent,
      ),
  },
  {
    path: routePath.privacyPreferences,
    loadComponent: () =>
      import('./general/opt-in-data-request-form/opt-in-data-request-form.component').then(
        (c) => c.OptInDataRequestFormComponent,
      ),
  },
  {
    path: routePath.copyrightReport,
    loadComponent: () =>
      import('./general/copyright-report-form/copyright-report-form.component').then(
        (c) => c.CopyrightReportFormComponent,
      ),
  },
  {
    path: routePath.contactUs,
    loadComponent: () =>
      import('./general/contact-us/contact-us.component').then(
        (c) => c.ContactUsComponent,
      ),
  },
  {
    path: routePath.privacyViolation,
    loadComponent: () =>
      import('./general/privacy-report-form/privacy-report-form.component').then(
        (c) => c.PrivacyReportFormComponent,
      ),
  },
  {
    path: routePath.login,
    loadComponent: () => import('./auth/login/login.component').then((c) => c.LoginComponent),
  },
  { path: '**', pathMatch: 'full', redirectTo: '/' },
];
